var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.newouterVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.newouterVisible=$event}}},[_c('img',{attrs:{"src":_vm.img_status}})])}
var staticRenderFns = []

export { render, staticRenderFns }